<div
  class="group/item h-[48px]"
  [cdkDragDisabled]="!peutModifier()"
  [cdkDragData]="ressource()"
  [draggable]="peutModifier()"
  cardItem
  cdkDrag
>
  <span cardItemTitle>{{ (ressource().indice ?? 0) + 1 }}. {{ ressource().nom }}</span>
  @if (peutModifier()) {
    <div class="py-xxs invisible group-hover/item:visible" cardItemActions>
      <button
        [hlmDropdownMenuTrigger]="actionsRessourceProfessionnelleMenu"
        [hlmDropdownMenuTriggerData]="{ $implicit: { item: ressource() } }"
        (click)="$event.stopPropagation()"
        hlmBtn
        variant="ghost"
      >
        <ng-icon name="lucideEllipsisVertical" />
      </button>
    </div>
  }
</div>

<ng-template #actionsRessourceProfessionnelleMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of ressourcesAction; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
        @if (action.shortcut) {
          <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
        }
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
